// extracted by mini-css-extract-plugin
export var activityContainer = "_lo-0";
export var typingIndicatorContainer = "_lo-1";
export var typingIndicatorDot = "_lo-2";
export var wave = "_lo-3";